const Checkbox = ({ onChangeCallback, checked, otherAttributes }) => {
  return (
    <input
      type="checkbox"
      className="form-checkbox rounded flex-no-shrink p-2 mr-2 border-2 border-green"
      onChange={onChangeCallback}
      checked={checked}
      {...otherAttributes}
    />
  );
};

export default Checkbox;
